module.exports = __webpack_public_path__ + "dist/media/logo--en.64eed153.svg";